<article class="formEditor">
    @if (hasLabel()) {
        <span class="formLabel">{{ labelText() }}</span>
    }
    <lib-generic-type-ahead-multiselect
        [source]="items()"
        [selectedItems]="selectedItems()"
        (selectedItemsChange)="onSelectedItemsChange($event)"
        [config]="{
            defaultText: placeholderText(),
            multiple: true,
            itemDisplayKey: 'fullName',
            itemTemplate: itemTemplate
        }"
        [placeholder]="placeholderText()"
        (textChange)="onEntityTextChange($event)"
        [isReadOnly]="isReadOnly()"
    >
        <ng-template #itemTemplate let-data>
            <app-custom-menu-item
                [inputText]="data.inputText"
                [title]="
                    $safeNavigationMigration(data.object?.firstName) +
                    ' ' +
                    $safeNavigationMigration(data.object?.lastName)
                "
                [subtitle]="data.object?.email ?? ''"
                [titlePrefix]="!data.object?.isActive ? { text: 'Inactive', textColor: 'danger' } : undefined"
            >
            </app-custom-menu-item>
        </ng-template>
    </lib-generic-type-ahead-multiselect>
</article>
